export default "__VITE_ASSET__DrHzUb_F__"